function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceGone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.35,13.65,24.6,11.78V7A.67.67,0,0,0,24,6.27H20.65a.67.67,0,0,0-.67.67h0V8.61L16.4,6.12a.68.68,0,0,0-.77,0l-11,7.53a.69.69,0,0,0-.19.95l0,0a.68.68,0,0,0,.55.29.58.58,0,0,0,.38-.13l2-1.35V25.33a.67.67,0,0,0,.67.67H23.93a.67.67,0,0,0,.67-.65h0V13.41l2,1.35a.58.58,0,0,0,.38.13.7.7,0,0,0,.56-.29A.69.69,0,0,0,27.35,13.65Zm-6-6h1.94v3.23L21.34,9.56Zm-3.89,17H14.61V18.14h2.8Z",
    style: {
      fill: "#7e7e7e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceGone);
export default __webpack_public_path__ + "static/media/presence-gone.a1373704.svg";
export { ForwardRef as ReactComponent };